import DataTile from "./DataTile";
import {fetchPerimeterAttacksMetaAction,} from "../../../actions";
import React from "react";
import { bbTranslateRiskToColor} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import RiskRibbon from "../../risk/RiskRibbon";
import BBIconJollyRogerSkull from "../../../assets/bbCustomIcons/BBIconJollyRogerSkull";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    // const customer = customers ? customers[customerIdToUse] ? customers[customerIdToUse] : null : null;
    //from the customer, pull the target data if it exists

    //example data in stateData as of 05Jan2021
    // "total": {
    //     "attacks": 1,
    //     "perimeter": 0,
    //     "perimeter_defeated": 0,
    //     "phishing": 1,
    //     "phishing_defeated": 0
    // },
    // "30_days": {
    //     "attacks": 0,
    //     "perimeter": 0,
    //     "perimeter_defeated": 0,
    //     "phishing": 0,
    //     "phishing_defeated": 0
    // }


    const valueFunction = (stateData) => {
        if (stateData) {
            try {
                //destructure state data
                const {
                    [customerIdToUse] : {
                        total : {
                            attacks,
                            // perimeter,
                            perimeter_defeated,
                            // phishing,
                            phishing_defeated
                        }
                    }
                } = stateData

                //calculate desired value
                const numSuccessfulAttacks = attacks - perimeter_defeated - phishing_defeated;

                //stupid check, return, and broadcast problems
                if (numSuccessfulAttacks >= 0) {
                    return numSuccessfulAttacks
                } else {
                    console.warn(
                        __filename,"failed stupid check. Wanted number of successful attacks.  used: numSuccessfulAttacks",
                        numSuccessfulAttacks,
                        "attacks",
                        attacks,
                        "perimeter_defeated",
                        perimeter_defeated,
                        "phishing_defeated",
                        phishing_defeated,
                        "from state stateData[customerIdToUse]",
                        stateData[customerIdToUse]);
                    return null
                }
            } catch {
                return null
            }
        } else {
            return null
        }

    }

    const translateValueToRisk = (value) => {
        if (typeof value !== "number") {
            return null
        } else if (value <= 0) {
            return 0
        } else if (value <= 2) {
            return 1
        } else if (value <= 15) {
            return 2
        } else if (value <= 40) {
            return 3
        } else {
            return 4
        }
    }

    const colorFunction = (stateData) => {
        const num = valueFunction(stateData);
        return bbTranslateRiskToColor(translateValueToRisk(num));
    }

    const riskRibbon = (stateData) => {
        const num = translateValueToRisk(valueFunction(stateData));
        return num
            ? <RiskRibbon ratingBy5={num} />
            : null;
    }

    return (
        <DataTile
            colorBgFunction={colorFunction}
            subTitle="Lifetime Breaches"
            tipText={"The total number CIRT attacks that have caused a breach over the lifetime of your CIRT subscription."}
            icon={<BBIconJollyRogerSkull style={{fontSize: "70px"}}/>}
            stateName="customer"
            stateElement="metaAttacks"
            // useDeepDataStore
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].targets : null : null}
            stateLoaderName="loadingMetaAttacks"
            stateLoaderError="loadingMetaAttacksError"
            stateFetchAction={fetchPerimeterAttacksMetaAction({
                customerId: customerIdToUse
            })}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={riskRibbon}
            requiresModule={"perimeter"}
        />
    );
}

export default Tile;